import { render, staticRenderFns } from "./SyllabusesList.vue?vue&type=template&id=4f893337&scoped=true&"
import script from "./SyllabusesList.vue?vue&type=script&lang=js&"
export * from "./SyllabusesList.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusesList.vue?vue&type=style&index=0&id=4f893337&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f893337",
  null
  
)

export default component.exports